<template>
    <div class="footer-area-wrapper" :class="FooterStyle">
        <div class="footer-area section-space--ptb_90">
            <div class="container">
                <div class="row footer-widget-wrapper">
                    <div class="col-lg-3 col-md-6 footer-widget">
                        <div class="footer-widget__logo mb-30">
                            <router-link to="/">
                                <img src="../assets/img/logo/logo-dark.png" class="img-fluid logo-dark footer-logo" alt="logo">
                            </router-link>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 footer-widget">
                        <h6 class="footer-widget__title mb-20">Contact</h6>
                        <ul class="footer-widget__list">
                            <li>
                                <a href="mailto:info@whaleio.com" class="hover-style-link">info@whaleio.com</a>
                            </li>
                            <li>
                                <a href="tel:2566847771" class="hover-style-link">256.684.7771</a>
                            </li>
                            <li>
                                <a href="https://www.whaleio.com" target="_blank" class="hover-style-link hover-style-link--green">www.whaleio.com</a>
                            </li>
                        </ul>
                    </div>
					<div class="col-lg-3 col-md-6 footer-widget">
                        <h6 class="footer-widget__title mb-20">Quick links</h6>
                        <ul class="footer-widget__list">
                            <li>
                                <router-link to="/privacy" class="hover-style-link">Privacy Policy</router-link>
                            </li>
                            <li>
                                <router-link to="/covid" class="hover-style-link">Covid Precautions</router-link>
                            </li>
                            <li>
                                <a href="https://whaleio.sharepoint.us" class="hover-style-link">Employee Portal</a>
                            </li>
                        </ul>
                    </div>
					<div class="col-lg-3 col-md-6 footer-widget">
                        <h6 class="footer-widget__title mb-20">NAICS Codes</h6>
                        <ul class="footer-widget__list">
                            <li>
                                541715 R&D in the Physical, Engineering, and Life Sciences
                            </li>
                            <li>
                                541330 Engineering Services
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright-area border-top section-space--ptb_30">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 text-center text-md-left">
                        <span class="copyright-text">
                            &copy; 2021 <b>Whaleio LLC</b>
                        </span>
                    </div>
                    <div class="col-md-6 text-center text-md-right">
                        <ul class="list ht-social-networks solid-rounded-icon">
                            <li class="item">
                                <a href="https://www.linkedin.com/company/whaleio-llc" target="_blank" class="social-link"> <i class="fab fa-linkedin social-link-icon"></i> </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FooterMain',
        props: ["FooterStyle"]
    }
</script>

<style lang="scss">
.footer-logo{
	max-width:220px;
}
</style>
